const initialState = () => ({
  loading: false,
  error: "",
  showPop: false,
  msgHeading: "",
  msgText: "",
  msgColor: "",
});

const state = initialState ();

const getters = {
  loading: (state) => state.loading,
  error: (state) => state.error,
  showPop: (state) => state.showPop,
  msgHeading: (state) => state.msgHeading,
  msgText: (state) => state.msgText,
  msgColor: (state) => state.msgColor,
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  clearError(state) {
    state.error = null;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setShowPop(state, payload) {
    state.showPop = payload;
  },
  setMsgHeading(state, payload) {
    state.msgHeading = payload;
  },
  setMsgText(state, payload) {
    state.msgText = payload;
  },
  setMsgColor(state, payload) {
    state.msgColor = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getLoading({ commit }, payload) {
    commit("setLoading", payload);
  },

  getShowPop({ commit }, payload) {
    commit("setShowPop", payload);
  },

  getClearError({ commit }) {
    commit("clearError");
  },

  getError({ commit }, payload) {
    commit("setError", payload);
  },

  getMsgHeading({ commit }, payload) {
    commit("setMsgHeading", payload);
  },

  getMsgText({ commit }, payload) {
    commit("setMsgText", payload);
  },

  getMsgColor({ commit }, payload) {
    commit("setMsgColor", payload);
  },

};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
